module.exports = __webpack_public_path__ + "img/the-burning-god.53feca5b.png";